export default "__VITE_ASSET__DmBlVArJ__"